import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { UserService } from "app/core/user/user.service";
import { ToastrService } from "ngx-toastr";


@Component({
    selector       : 'profile-img-dialog',
    templateUrl    : './profile-img-dialog.component.html',
    styleUrls: ['./profile-img-dialog.component.scss'],
})
export class ProfileImgDialogComponent
{
    files: File[] = [];
    acceptedImageTypes = '.jpg,.jpeg,.png,image/jpeg,image/png';
    maxSizeInMB = 10;
    private readonly allowedMimeTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    private readonly allowedExtensions = ['jpg', 'jpeg', 'png'];

    constructor(private _userService: UserService,
        private _toastrService: ToastrService,
        private dialogRef: MatDialogRef<ProfileImgDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data
    ){}

    onSelect(event){

        if(this.files.length == 1){
            this._toastrService.error("Only one file allow to upload");
            return;
        }

        if (event.rejectedFiles?.length) {
            this._toastrService.error("Only jpeg/jpg/png file supported");
            return;
        }

        const addedFile = event.addedFiles?.[0];
        if (!addedFile) {
            return;
        }

        const maxSizeBytes = this.maxSizeInMB * 1024 * 1024;
        if (addedFile.size > maxSizeBytes) {
            this._toastrService.error("File size allow 10MB only");
            return;
        }

        const extension = (addedFile.name.split('.').pop() || '').toLowerCase();
        const mimeOk = !addedFile.type || this.allowedMimeTypes.includes(addedFile.type);
        if (!mimeOk || !this.allowedExtensions.includes(extension)) {
            this._toastrService.error("Only jpeg/jpg/png file supported");
            return;
        }

        let file = this.files.filter(x=>x.name == addedFile.name);
        if(file.length == 0){
            this.files.push(...event.addedFiles);
        }
        else{
            this._toastrService.error("Duplicate file not allowed.");
            return;
        }
    }

    onRemove(event){
        this.files.splice(this.files.indexOf(event), 1);
    }

    UploadDocument(){
        const formData = new FormData();
        formData.append("formFile", this.files[0]);
        
        this._userService.apiPostUserPhoto(formData, localStorage.getItem("userId")).subscribe(
            (response)=>{
                this._toastrService.success("Successfully uploaded");
                this.dialogRef.close(true);
            },
            (error)=>{
                this._toastrService.error(error?.error?.failureMessage || "Error uploading photo");
            }
        );
    }

    CloseClick(){
        this.dialogRef.close(false);
    }
}